import { arrayWrap } from "@ncs/ts-utils"

export type PriceRange = {
	id: string
	min: number | null
	max: number | null
	text: string
}

const ACCESSORIES_CATEGORY = "Accessories"

type QueryParamArray = string | number | (string | number)[] | null | undefined

interface NamedFilterItem {
	id: number | string
	name: string | null | undefined
}

interface PartSearchOrderingOptions {
	ordering?: string | null
	categories?: QueryParamArray
	chemicals?: QueryParamArray
	brands?: QueryParamArray
	manufacturers?: QueryParamArray
	chemicalCategories?: NamedFilterItem[]
}

export const getPartSearchOrdering = ({
	ordering,
	categories,
	chemicals,
	brands,
	manufacturers,
	chemicalCategories,
}: PartSearchOrderingOptions): string => {
	if (ordering) return ordering

	const hasCategories = arrayWrap(categories).length > 0
	const hasChemicals = arrayWrap(chemicals).length > 0
	const hasBrands = arrayWrap(brands).length > 0
	const hasManufacturers = arrayWrap(manufacturers).length > 0
	const accessoriesId = chemicalCategories?.find(
		(chemical) => chemical.name === ACCESSORIES_CATEGORY
	)?.id
	const haveJustAccessories =
		hasChemicals &&
		arrayWrap(chemicals).every((chemicalId) => String(chemicalId) === String(accessoriesId))

	return (
			hasCategories ||
				haveJustAccessories ||
				(hasBrands && (!hasChemicals || haveJustAccessories)) ||
				hasManufacturers
		) ?
			"-visit_count"
		:	"title"
}

export const priceRanges: PriceRange[] = [
	{ id: "1", min: 0, max: 25, text: "Up to $25" },
	{ id: "2", min: 25, max: 50, text: "$25 - $50" },
	{ id: "3", min: 50, max: 200, text: "$50 - $200" },
	{ id: "4", min: 200, max: 500, text: "$200 - $500" },
	{ id: "5", min: 500, max: 1000, text: "$500 - $1000" },
	{ id: "6", min: 1000, max: null, text: "$1000+" },
]
